import { render } from "./ParticipantProfile.vue?vue&type=template&id=d0bb3b5e&scoped=true"
import script from "./ParticipantProfile.vue?vue&type=script&lang=js"
export * from "./ParticipantProfile.vue?vue&type=script&lang=js"

import "./ParticipantProfile.vue?vue&type=style&index=0&id=d0bb3b5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0bb3b5e"]])

export default __exports__